<script setup lang="ts">
import { useTranslation } from 'i18next-vue';

import { ButtonGroupMenuItem, DottedButtonGroup } from './';
import type { DottedMenuItem } from './types/DottedMenu.type';

const { t } = useTranslation();

defineProps({
  items: {
    type: Array<DottedMenuItem>,
    required: true
  }
});
</script>

<template>
  <DottedButtonGroup>
    <ButtonGroupMenuItem
      v-for="item of items"
      :key="item.label"
      :data-test-id="`dotted-menu-option-${item.label}`"
      :text="t(item.label)"
      :icon-name="item.icon"
      :class="item.class"
      :is-disabled="item.isDisabled"
      @[!item.isDisabled&&`click`]="item.action"
    />
  </DottedButtonGroup>
</template>

<style scoped>
.dotted-menu-item {
  position: relative;
}
</style>
